module.exports = __webpack_public_path__ + "static/media/GMA-S2100-1AER_OR13_beautyshot1.5b3528a5.jpg";